import React, { useContext, useEffect, useState, memo } from 'react'

//Language
import { I18nContext } from '../context/I18nProvider'
import { useTranslation } from 'react-i18next'

const LanguageSelector = () => {
    const { i18n } = useTranslation()
    const { language } = useContext(I18nContext)
    const [buttonFocus, setButtonFocus] = useState('')

    //El idioma lo cambiamos con la instancia de i18n para no correr 2 veces el contexto
    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang)
    }

    useEffect(() => {
        setButtonFocus(language)
    }, [language])

    return (
        <div className="language-selector">
            <button
                className={`btn-lang ${buttonFocus === 'en' ? 'active' : ''}`}
                aria-label="Change to english language"
                onClick={() => changeLanguage('en')}
                disabled={language === 'en'} //Deshabilito el boton si ya se esta en ingles
            ></button>
            <button
                className={`btn-lang ${buttonFocus === 'es' ? 'active' : ''}`}
                aria-label="Cambiar idioma a español"
                onClick={() => changeLanguage('es')}
                disabled={language === 'es'}
            ></button>
            <button
                className={`btn-lang ${buttonFocus === 'pt' ? 'active' : ''}`}
                aria-label="Cambiar idioma a portugues"
                onClick={() => changeLanguage('pt')}
                disabled={language === 'pt'}
            ></button>
        </div>
    )
}

export default memo(LanguageSelector)
